// import React, { useEffect, useState } from "react";
// import {
//     Bar,
//     Line,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     ResponsiveContainer,
//     ComposedChart,
//     LabelList,
//     Legend
// } from "recharts";
// import { PrAnalysisTab2Api } from "../../../../../api/Api";
// import { FaCrosshairs } from 'react-icons/fa';
// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Ensure you import the autoTable plugin
// import * as XLSX from "xlsx";
// import logo from '../../../../../assets/img/logos/logo 2.png';
// // import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../utils'
// import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
// import {
//     Box,
//     Card,
//     CardContent,
//     Grid,
//     Typography,
//     useTheme,
//     CardActions,
//     Button
// } from "@mui/material";

// import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../api/AxiosApi'
// import ExportExcel from '../../../../../components/exportExcel/ExportExcel1';
// import ExportPdf from "../../../../../components/exportPdf/ExportPdf";
// // Function to get default dates
// export function getDateTimeForDashboardTab1(date = new Date()) {
//     const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
//     const tenDaysAgo = new Date(date);
//     tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
//     const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

//     return {
//         Today: formattedCurrentDate,
//         LastDay: formattedTenDaysAgo,
//     };
// }

// const PrAnalysisTab2 = () => {
//     const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

//     const [chartData, setChartData] = useState([]);
//     const [chartData2, setChartData2] = useState([]);
//     const [chartData3, setChartData3] = useState([]);
//     const [chartData4, setChartData4] = useState([]);
//     const [chartData5, setChartData5] = useState([]);
//     const [chartData6, setChartData6] = useState([]);
//     const theme = useTheme();
//     const { palette, spacing, shape: { borderRadius } } = useTheme()

//     // table 
//     // Pagination States
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(10);
//     const [logData, setLogData] = useState([])
//     const [loading, setLoading] = useState(true);


//     const credentials = {
//         LOGIN_ID: sessionStorage.getItem("LoginID") ?? "",
//         LCODE: sessionStorage.getItem("LCODE") ?? "",
//         PASS_KEY: sessionStorage.getItem("PASS_KEY") || "XYZ",
//         WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
//         DT1: StartDate, // Default Start Date
//         DT2: EndDate, // Default End Date
//     };

//     // Fetch data from the API
//     const fetchLogData = async () => {
//         setLoading(false);
//         try {
//             const res = await PrAnalysisTab2Api(credentials);


//             if (res?.data && Array.isArray(res.data)) {
//                 // console.log("Fetched Data:", res.data);
//                 setLogData(res.data);

//                 // Transform the API data of Chart1
//                 const transformedData = res.data.map((item) => ({
//                     name: item.DT || "N/A", // Use `DATET` for labels on X-axis
//                     POWER: parseFloat(item.POWER) || 0, // PR value
//                     RAD: parseFloat(item.RAD) || 0, // CUF value
//                 }));

//                 setChartData(transformedData);

//                 // Transform the API data of chart2
//                 const transformedData2 = res.data.map((item) => ({
//                     name: item.DT || "N/A", // Use `DATET` for labels on X-axis
//                     RAD: parseFloat(item.RAD) || 0, // PR value
//                     PR: parseFloat(item.PR) || 0, // CUF value
//                 }));

//                 setChartData2(transformedData2);

//                 // Transform the API data of chart3
//                 const transformedData3 = res.data.map((item) => ({
//                     name: item.DT || "N/A", // Use `DATET` for labels on X-axis
//                     POWER: parseFloat(item.POWER) || 0, // PR value
//                     Expected_Gen: parseFloat(item.Expected_Gen) || 0, // CUF value
//                     RAD: parseFloat(item.RAD) || 0, // PR value
//                 }));

//                 setChartData3(transformedData3);



//             } else {
//                 // console.error("Data structure mismatch:", res);
//                 setChartData([]); // Handle invalid data response
//                 setChartData2([]); // Handle invalid data response

//             }
//         } catch (err) {
//             // console.error("Error fetching data:", err);
//         }
//     };

//      const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

//     useEffect(() => {
//         fetchLogData();
//     }, []);




//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(logData.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Define keys to exclude (you can also define keys to include instead)
//     const excludeKeys = ["LCODE"]; // Replace "key1", "key2" with actual keys you don't want to export

//     // Filter logData
//     const filteredLogData = logData.map((item) => {
//         const filteredItem = {};
//         Object.keys(item).forEach((key) => {
//             if (!excludeKeys.includes(key)) {
//                 filteredItem[key] = item[key]; // Include keys not in excludeKeys
//             }
//         });
//         return filteredItem;
//     });

//     // Get table headers from filteredLogData
//     const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];

//     // Export to Excel
//     // const exportToExcel = () => {
//     //     const ws = XLSX.utils.json_to_sheet(filteredLogData);
//     //     const wb = XLSX.utils.book_new();
//     //     XLSX.utils.book_append_sheet(wb, ws, "PrAnalysis");
//     //     XLSX.writeFile(wb, `PrAnalysis To ${EndDate.replace(" ", "T")} PrAnalysis.xls`);
//     // };

//     const exportToExcel = async () => {
//         await ExportExcel(
//             ImageUrl,
//             filteredLogData,
//             StartDate,
//             EndDate,
//             "PrAnalysis Log",
//             LoggedInUserInfo
//         );
//     };

//     // Export to PDF
//     // const exportToPDF = () => {
//     //     const doc = new jsPDF();

//     //     // Add Logo (x, y, width, height)
//     //     const imgWidth = 30;  // Adjust width
//     //     const imgHeight = 20; // Adjust height
//     //     const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
//     //     doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

//     //     // Add Title or Text Below the Logo
//     //     const title = `PrAnalysis To ${EndDate.replace(" ", "T")}`;
//     //     doc.setFontSize(12);  // Adjust font size
//     //     doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

//     //     // Adjust Y position for the table to start below the text
//     //     let startY = 50;  // Push table further down below text

//     //     doc.autoTable({
//     //         head: [tableHeaders],
//     //         body: currentData.map((item) => tableHeaders.map((key) => item[key])),
//     //         startY: startY,  // Start table below the logo and text
//     //         theme: "grid",
//     //     });

//     //     doc.save(`PrAnalysis To ${EndDate.replace(" ", "T")} PrAnalysis`);
//     // };

//     const exportToPDF = async () => {
//         await ExportPdf(
//             ImageUrl,
//             currentData,
//             StartDate,
//             EndDate,
//             `PrAnalysis`,
//             LoggedInUserInfo,
//             logo,
//             tableHeaders

//         );
//     };

//     // Handle Start Date change
//     const handleStartDateChange = (value) => {
//         setStartDate(value); // Update the StartDate directly
//     };

//     // Handle End Date change
//     const handleEndDateChange = (value) => {
//         setEndDate(value); // Update the EndDate directly
//     };

//     // Refresh data only when clicking "Show"
//     function onRefreshData() {
//         if (StartDate.length !== 0 && EndDate.length !== 0) {
//             fetchLogData(); // Fetch data only after clicking the button
//         } else {
//             alert("Please provide valid dates");
//         }
//     }


//     return (
//         <Box bgcolor={"background.default"} py={2}>

//             <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
//                 <Grid key="chart-grid" item xs={12}>
//                     <Card>
//                         <CardActions sx={{
//                             display: "flex", // Enable flexbox
//                             justifyContent: "flex-end", // Align items to the right
//                             alignItems: "center", // Center items vertically
//                             gap: "16px", // Add some spacing between the inputs
//                         }}>
//                             <label>
//                                 From:&nbsp;
//                                 <input
//                                     type="date"
//                                     value={StartDate} // Use StartDate directly
//                                     onChange={(e) => handleStartDateChange(e.target.value)}
//                                     style={{
//                                         padding: "2px 2px",
//                                         borderRadius: "14px",
//                                         border: "1px solid #ccc",
//                                     }}
//                                 />
//                             </label>
//                             <label>
//                                 To:&nbsp;
//                                 <input
//                                     type="date"
//                                     value={EndDate} // Use EndDate directly
//                                     onChange={(e) => handleEndDateChange(e.target.value)}
//                                     style={{
//                                         padding: "2px 2px",
//                                         borderRadius: "14px",
//                                         border: "1px solid #ccc",
//                                     }}
//                                 />
//                             </label>

//                             <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
//                         </CardActions>
//                     </Card>
//                 </Grid>


//             </Grid>

//             <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
//                 <Grid item xs={12} md={12}>
//                     <Card>
//                         {/* Heading Box using Material UI Box */}
//                         <Box
//                             sx={{
//                                 padding: "4px",
//                                 borderRadius: "5px",
//                                 marginBottom: "15px",
//                                 textAlign: "start",
//                                 fontWeight: "bold",
//                                 fontSize: "16px",
//                                 border: "1px solid lightgray",

//                             }}
//                         >
//                             <FaCrosshairs style={{ marginRight: "10px", color: "black" }} />
//                             {/* Power[kW] Vs. Irradiation Curve[W/m²] */}
//                             Irradiance[W/m²] Vs. Power[kW] Curve


//                         </Box>

//                         <CardContent sx={{ padding: "2px" }}>
//                             {chartData.length > 0 ? (
//                                 <ResponsiveContainer width="100%" height={400}>
//                                     <ComposedChart data={chartData}>
//                                         <CartesianGrid strokeDasharray="3 3" />
//                                         <XAxis dataKey="name" />
//                                         <YAxis
//                                             yAxisId="left"
//                                             label={{
//                                                 value: "Irradiance",
//                                                 angle: -90,
//                                                 position: "insideLeft",
//                                             }}
//                                         />
//                                         <YAxis
//                                             yAxisId="right"
//                                             orientation="right"
//                                             label={{
//                                                 value: "POWER",
//                                                 angle: 90,
//                                                 position: "insideRight",
//                                             }}
//                                         />
//                                         <Tooltip />

//                                         {/* Add Legend at the Top */}
//                                         <Legend
//                                             layout="horizontal"
//                                             verticalAlign="top"
//                                             align="center"
//                                             wrapperStyle={{ paddingBottom: "10px" }}
//                                         />

//                                         {/* PR Bar */}
//                                         <Bar
//                                             dataKey="RAD"
//                                             fill={LoggedInUserInfo.dash_color}
//                                             name="Irradiance"
//                                             yAxisId="left"
//                                         />

//                                         {/* CUF Line */}
//                                         <Line
//                                             type="monotone"
//                                             dataKey="POWER"
//                                             stroke="#808080"
//                                             name="POWER"
//                                             yAxisId="right"
//                                             dot={false}
//                                             strokeWidth={2}
//                                         />
//                                     </ComposedChart>
//                                 </ResponsiveContainer>
//                             ) : (
//                                 <Typography
//                                     variant="body1"
//                                     color="textSecondary"
//                                     textAlign="center"
//                                 >
//                                     No data available for the selected range.
//                                 </Typography>
//                             )}
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             </Grid>


//             <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
//                 <Grid item xs={12} md={12}>
//                     <Card>
//                         <Box
//                             sx={{
//                                 padding: "4px",
//                                 borderRadius: "5px",
//                                 marginBottom: "15px",
//                                 textAlign: "start",
//                                 fontWeight: "bold",
//                                 fontSize: "16px",
//                                 border: "1px solid lightgray",

//                             }}
//                         >

//                             <FaCrosshairs style={{ marginRight: "10px", color: "black" }} />
//                             {/* Irradiation[W/m²] Vs. PR Curve */}

//                             PR Vs. Irradiance[W/m²] Curve

//                         </Box>

//                         <CardContent sx={{ padding: "2px" }}>
//                             {chartData2.length > 0 ? (
//                                 <ResponsiveContainer width="100%" height={400}>
//                                     <ComposedChart
//                                         data={chartData2}
//                                         margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
//                                     >
//                                         <CartesianGrid strokeDasharray="3 3" />
//                                         <XAxis dataKey="name" />
//                                         <YAxis
//                                             yAxisId="left"
//                                             label={{
//                                                 value: "PR",
//                                                 angle: -90,
//                                                 position: "insideLeft",
//                                             }}
//                                         />
//                                         <YAxis
//                                             yAxisId="right"
//                                             orientation="right"
//                                             label={{
//                                                 value: "Irradiance",
//                                                 angle: 90,
//                                                 position: "insideRight",
//                                             }}
//                                         />
//                                         <Tooltip />

//                                         {/* Add Legend */}
//                                         <Legend
//                                             layout="horizontal" // Horizontal alignment of legend items
//                                             verticalAlign="top" // Position the legend at the top of the chart
//                                             align="center" // Center-align the legend horizontally
//                                             wrapperStyle={{
//                                                 paddingBottom: "10px", // Add spacing below the legend
//                                                 fontSize: "12px", // Adjust font size
//                                             }}
//                                         />

//                                         {/* Solar Insolation Bar */}
//                                         <Bar
//                                             dataKey="PR"
//                                             fill={LoggedInUserInfo.dash_color}
//                                             name="PR" // Legend label
//                                             yAxisId="left"
//                                         />

//                                         {/* PR Line */}
//                                         <Line
//                                             type="monotone"
//                                             dataKey="RAD"
//                                             stroke="#808080"
//                                             name="Irradiance" // Legend label
//                                             yAxisId="right"
//                                             dot={false} // Disables dots on the line
//                                             strokeWidth={2}
//                                         />
//                                     </ComposedChart>
//                                 </ResponsiveContainer>
//                             ) : (
//                                 <Typography
//                                     variant="body1"
//                                     color="textSecondary"
//                                     textAlign="center"
//                                 >
//                                     No data available for the selected range.
//                                 </Typography>
//                             )}
//                         </CardContent>


//                     </Card>
//                 </Grid>

//             </Grid>

//             <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
//                 <Grid item xs={12} md={12}>
//                     <Card>

//                         <Box
//                             sx={{
//                                 padding: "4px",
//                                 borderRadius: "5px",
//                                 marginBottom: "15px",
//                                 textAlign: "start",
//                                 fontWeight: "bold",
//                                 fontSize: "16px",
//                                 border: "1px solid lightgray",

//                             }}
//                         >
//                             <FaCrosshairs style={{ marginRight: "10px", color: "black" }} />
//                             Actual Power[kW] vs Expected Power[kW]


//                         </Box>


//                         <CardContent sx={{ padding: "2px" }}>
//                             {chartData2.length > 0 ? (
//                                 <ResponsiveContainer width="100%" height={400}>
//                                     <ComposedChart
//                                         data={chartData3}
//                                         margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
//                                     >
//                                         <CartesianGrid strokeDasharray="3 3" />
//                                         <XAxis dataKey="name" />
//                                         <YAxis
//                                             yAxisId="left"
//                                             label={{
//                                                 value: "Irradiance",
//                                                 angle: -90,
//                                                 position: "insideLeft",
//                                             }}
//                                         />
//                                         <YAxis
//                                             yAxisId="right"
//                                             orientation="right"
//                                             label={{
//                                                 value: "Expected_Gen",
//                                                 angle: 90,
//                                                 position: "insideRight",
//                                             }}
//                                         />

//                                         <YAxis
//                                             yAxisId="right"
//                                             orientation="right"
//                                             label={{
//                                                 value: "POWER",
//                                                 angle: 90,
//                                                 position: "insideRight",
//                                             }}
//                                         />
//                                         <Tooltip />

//                                         {/* Add Legend */}
//                                         <Legend
//                                             layout="horizontal" // Horizontal alignment of legend items
//                                             verticalAlign="top" // Position the legend at the top of the chart
//                                             align="center" // Center-align the legend horizontally
//                                             wrapperStyle={{
//                                                 paddingBottom: "10px", // Add spacing below the legend
//                                                 fontSize: "12px", // Adjust font size
//                                             }}
//                                         />

//                                         {/* Solar Insolation Bar */}
//                                         <Bar
//                                             dataKey="RAD"
//                                             fill={LoggedInUserInfo.dash_color}
//                                             name="Irradiance" // Legend label
//                                             yAxisId="left"
//                                         />

//                                         {/* PR Line */}
//                                         <Line
//                                             type="monotone"
//                                             dataKey="Expected_Gen"
//                                             stroke="#808080"
//                                             name="Expected_Gen" // Legend label
//                                             yAxisId="right"
//                                             dot={false} // Disables dots on the line
//                                             strokeWidth={2}
//                                         />

//                                         <Line
//                                             type="monotone"
//                                             dataKey="POWER"
//                                             stroke="green"
//                                             name="POWER" // Legend label
//                                             yAxisId="right"
//                                             dot={false} // Disables dots on the line
//                                             strokeWidth={2}
//                                         />
//                                     </ComposedChart>
//                                 </ResponsiveContainer>
//                             ) : (
//                                 <Typography
//                                     variant="body1"
//                                     color="textSecondary"
//                                     textAlign="center"
//                                 >
//                                     No data available for the selected range.
//                                 </Typography>
//                             )}
//                         </CardContent>



//                     </Card>
//                 </Grid>

//             </Grid>


//             <div style={{ padding: "10px", marginTop: "2rem" }}>
//                 {/* Controls */}
//                 <div className="row">
//                     <div className="col-md-12">
//                         <div style={containerStyle} className="head">
//                             <p style={responsiveHeaderStyle}>PR Analysis</p>
//                             <div style={responsiveControlsStyle}>

//                                 <button onClick={fetchLogData} style={buttonStyle}>
//                                     Show
//                                 </button>
//                                 <button onClick={exportToExcel} style={exportButtonStyle}>
//                                     Excel
//                                 </button>
//                                 <button onClick={exportToPDF} style={exportButtonStyle2}>
//                                     PDF
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 {/* Table */}
//                 <div className="table-responsive">
//                     <table className="table table-hover table-bordered">
//                         <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                             <tr>
//                                 <th style={tableHeading}> Date </th>
//                                 <th style={tableHeading}>Irradiance[W/m²]</th>
//                                 <th style={tableHeading}> Power Generation[kW]</th>
//                                 <th style={tableHeading}> PR </th>
//                                 <th style={tableHeading}> Expected Generation[kW] </th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {loading ? (
//                                 <tr>
//                                     <td colSpan={tableHeaders.length} className="text-center">
//                                         Loading...
//                                     </td>
//                                 </tr>
//                             ) : currentData.length > 0 ? (
//                                 currentData.map((item, rowIndex) => (
//                                     <tr key={rowIndex}>

//                                         <td className="text-center align-middle" style={tableBody}>
//                                             {item.DT ?? ""}
//                                         </td>

//                                         <td className="text-center align-middle" style={tableBody}>
//                                             {item.RAD ?? ""}
//                                         </td>

//                                         <td className="text-center align-middle" style={tableBody}>
//                                             {item.POWER ?? ""}
//                                         </td>
//                                         <td className="text-center align-middle" style={tableBody}>
//                                             {item.PR ?? ""}
//                                         </td>
//                                         <td className="text-center align-middle" style={tableBody}>
//                                             {item.Expected_Gen ?? ""}
//                                         </td>


//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan={tableHeaders.length} className="text-center">
//                                         No data available
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Pagination */}
//                 <div style={{ textAlign: "right", marginTop: "10px" }}>
//                                             <button
//                                                 onClick={() => handlePageChange(currentPage - 1)}
//                                                 disabled={currentPage === 1}
//                                                 style={paginationButtonStyle}
//                                             >
//                                                 Previous
//                                             </button>

//                                             {[...Array(totalPages)].map((_, index) => {
//                                                 const isActive = currentPage === index + 1;
//                                                 return (
//                                                     <button
//                                                         key={index}
//                                                         onClick={() => handlePageChange(index + 1)}
//                                                         style={{
//                                                             ...paginationButtonStyle,
//                                                             backgroundColor: isActive ? "#356E35" : "white",
//                                                             color: isActive ? "#fff" : "#356E35",
//                                                         }}
//                                                     >
//                                                         {index + 1}
//                                                     </button>
//                                                 );
//                                             })}

//                                             <button
//                                                 onClick={() => handlePageChange(currentPage + 1)}
//                                                 disabled={currentPage === totalPages}
//                                                 style={paginationButtonStyle}
//                                             >
//                                                 Next
//                                             </button>
//                                         </div>
//             </div>

//         </Box>
//     );
// };

// export default PrAnalysisTab2;



// /* Styles */

// const containerStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     flexWrap: "wrap",
//     marginBottom: "7px",
//     border: "1px solid lightgray",
//     padding: "3px",
//     borderRadius: "7px"
// };

// const responsiveHeaderStyle = {
//     fontWeight: "bold",
//     margin: "0",
//     display: "flex",
//     flexWrap: "wrap"
// };

// const responsiveControlsStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "10px",
//     justifyContent: "center",
// };

// const inputStyle = {
//     padding: "2px 2px",
//     borderRadius: "14px",
//     border: "1px solid #ccc",
//     // marginLeft: "5px",
//     // fontSize: "10px",
// };

// const buttonStyle = {
//     backgroundColor: "#007BFF",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "2px 9px",
//     cursor: "pointer",
//     fontSize: "10px",
// };

// const exportButtonStyle = {
//     backgroundColor: "darkblue",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "3px 9px",
//     cursor: "pointer",
//     fontSize: "11px",
// };

// const exportButtonStyle2 = {
//     backgroundColor: "#f44336",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "3px 9px",
//     cursor: "pointer",
//     fontSize: "11px",
// };

// const paginationButtonStyle = {
//     backgroundColor: "white",
//     color: "#356E35",
//     border: "1px solid #ddd",
//     padding: "5px 10px",
//     borderRadius: "5px",
//     margin: "0 5px",
//     cursor: "pointer",
//     fontSize: "14px",
// };

// const tableHeading = {
//     color: "rgb(53, 110, 53)",
//     padding: "12px 10px",
//     fontSize: "14px",
//     whiteSpace: "nowrap",
// }

// const tableBody = {
//     padding: "5px",
//     whiteSpace: "nowrap",
// }



import React, { useEffect, useRef, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  Legend
} from "recharts";
import { FaCrosshairs } from "react-icons/fa";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme,
  CardActions,
  Button
} from "@mui/material";
import { AuthenticationContext } from "../../../../../../../context/AuthenticationContext";
import { PrAnalysisApi } from "../../../../../../../api/Api";
import DownloadJpegButton from "../../../../../../../components/downloadJpegButton/DownloadJpegButton";

export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0];
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0];
  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo
  };
}

const PrBottomChart = () => {
  const chartRef = useRef();
  const { LoggedInUserInfo } = React.useContext(AuthenticationContext);
  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);
  const [chartData2, setChartData2] = useState([]);
  const theme = useTheme();
  const { palette, shape: { borderRadius } } = useTheme();
  const [loading, setLoading] = useState(true);

  // Your credentials logic...
  const credentials = {
    USER: sessionStorage.getItem("LoginID") ?? "",
    LCODE: sessionStorage.getItem("LCODE") ?? "",
    PASS_KEY: sessionStorage.getItem("PASS_KEY") || "XYZ",
    WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
    DT1: StartDate,
    DT2: EndDate
  };

  // Fetch data from the API
  const fetchLogData = async () => {
    setLoading(true);
    try {
      const res = await PrAnalysisApi(credentials);
      if (res?.data && Array.isArray(res.data)) {
        const transformedData2 = res.data.map((item) => ({
          name: item.DATET || "N/A", // X axis label
          ENG: parseFloat(item.ENG) || 0, // Energy
          Expected_Generation: parseFloat(item.Expected_Generation) || 0, // Expected Generation
          PR: parseFloat(item.PR) || 0 // PR for line
        }));
        setChartData2(transformedData2);
      } else {
        setChartData2([]);
      }
    } catch (err) {
      // Handle error
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   fetchLogData();
  // }, []);

  useEffect(() => {
    // First fetch on component mount
    fetchLogData();
  
    // Auto refresh every 5 minutes (300000 ms)
    const interval = setInterval(() => {
      fetchLogData();
    }, 300000); // 5 minutes
  
    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);
  

  const handleStartDateChange = (value) => setStartDate(value);
  const handleEndDateChange = (value) => setEndDate(value);

  function onRefreshData() {
    if (StartDate.length !== 0 && EndDate.length !== 0) {
      fetchLogData();
    } else {
      alert("Please provide valid dates");
    }
  }

  return (
    <Box bgcolor={"background.default"} py={0}>
      <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
        <Grid item xs={12} md={12}>
          <Card>
            {/* Top Title Row */}
            <Box
              sx={{
                padding: "2px",
                borderRadius: "5px",
                marginBottom: "0px",
                textAlign: "start",
                fontWeight: "bold",
                fontSize: "14px",
                border: "1px solid lightgray",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between" // spread left-right
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <FaCrosshairs style={{ marginRight: "10px", color: "black" }} />
                Energy Generation [kWH] Vs PR  Vs Expected Generation[kWH]
              </Box>
             
              <CardActions sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "14px"
              }}>
                <label>
                  From:&nbsp;
                  <input
                    type="date"
                    value={StartDate}
                    onChange={(e) => handleStartDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc"
                    }}
                  />
                </label>
                <label>
                  To:&nbsp;
                  <input
                    type="date"
                    value={EndDate}
                    onChange={(e) => handleEndDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc"
                    }}
                  />
                </label>
                <Button onClick={onRefreshData} variant='contained'
                  sx={{
                    color: 'white',
                    p: 0, m: 0, fontSize: '12px',
                    backgroundColor: palette.tintBlue,
                    borderRadius: borderRadius
                  }}>
                  Show
                </Button>

                <DownloadJpegButton targetRef={chartRef} fileName={`Energy Generation [kWH] Vs PR Vs Expected Generation[kWH].jpeg`} />
              </CardActions>
            </Box>
            <CardContent ref={chartRef}  sx={{ padding: "2px" }}>
              {chartData2.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart
                    data={chartData2}
                    margin={{ top: 20, right: 20, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis yAxisId="left"
                      label={{
                        value: "Energy / Expected Generation",
                        angle: -90,
                        position: "insideLeft"
                      }}
                    />
                    <YAxis yAxisId="right"
                      orientation="right"
                      label={{
                        value: "PR",
                        angle: 90,
                        position: "insideRight"
                      }}
                    />
                    <Tooltip />
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      wrapperStyle={{
                        paddingBottom: "10px",
                        fontSize: "12px"
                      }}
                    />
                    {/* ENG bar */}
                    <Bar
                      dataKey="ENG"
                      fill="green"
                      name="Energy"
                      yAxisId="left"
                    />
                    {/* Expected Generation bar */}
                    <Bar
                      dataKey="Expected_Generation"
                      fill="#1565C0"
                      name="Expected Generation"
                      yAxisId="left"
                    />
                    {/* PR Line */}
                    <Line
                      type="monotone"
                      dataKey="PR"
                      stroke="#ff7043"
                      name="PR"
                      yAxisId="right"
                      dot={false}
                      strokeWidth={2}
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  textAlign="center"
                >
                  No data available for the selected range.
                </Typography>
              )}
            </CardContent>
          </Card>  
        </Grid>
      </Grid>
    </Box>
  );
};

export default PrBottomChart;


